export default "__VITE_ASSET__aD8UgHRS__"